import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';
import { Chip } from '@mui/material';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles()((theme, props) => ({
  root: {
    background: !props.editable ? colors.grey11 : colors.white,
    borderRadius: 16,
    border: !props.editable ? `1px solid ${colors.grey11}` : `1px solid ${colors.clearGray}`,
    margin: !props.editable ? 0 : 4,
    '&:focus': {
      background: colors.white,
    },
  },
  deleteIcon: {
    color: colors.black,
  },
  chipLabel: props.editable
    ? {
    fontSize: fontSize.medium,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: colors.textColor,
  } : {
    color: colors.grey1,
  },
}));

const CustomChip = ({ label, className, chipClasses, editable, ...rest }) => {
  const { classes, cx } = useStyles({ editable });

  return (
    <Chip
      classes={{
        root: cx(classes.root, className),
        deleteIcon: classes.deleteIcon,
        label: classes.chipLabel,
        ...chipClasses,
      }}
      label={label}
      {...rest}
    />
  );
};

CustomChip.defaultProps = {
  chipClasses: {},
  editable: true,
};

CustomChip.propTypes = {
  label: PropTypes.string.isRequired,
  chipClasses: PropTypes.object,
  editable: PropTypes.bool,
  className: PropTypes.string,
};

export default CustomChip;
